import{IconCheckmark75 as e}from"../src/elements/IconCheckmark75.js";customElements.define("sp-icon-checkmark75",e);
//# sourceMappingURL=sp-icon-checkmark75.js.map
